import {
    GelBoxLayout,
    GelContainerLite,
    GelIcon,
    GelLink,
} from '@tal-gel/components';
import { getGelTokens } from '@tal-gel/theming';
import { AdobeClickType, CLAIM_TYPE } from '../../constants/constants';
import { useNavigate } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { AdobeAnalytics } from '../../common/analytics/adobe-analytics';
import { ScheduledPaymentDetail } from '../../common/models/memberclaims';
import { FormatHelper } from '../../common/formatHelper.common';
import { formatDate } from '../payments/helpers';

interface NextPaymentProps {
    message: string;
    nextScheduledPayment: ScheduledPaymentDetail | undefined;
}
const NextPayment = ({ message, nextScheduledPayment }: NextPaymentProps) => {
    const { global: { sizeBaseX3, themeColorBackgroundLight, themeColorGrayT10, sizeBaseX2, themeColorBackgroundDark, sizeBaseUnit } } = getGelTokens()

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [{ tpid }] = useCookies(['tpid']);
    const navigate = useNavigate();

    const navigateToPayments = () => {
        const concatedLinkName = message + " " + nextScheduledPayment?.amount;
        AdobeAnalytics.PushClickEvent(tpid, concatedLinkName, AdobeClickType.Link)

        navigate("/payments");
    };

    const requirements =
        nextScheduledPayment && nextScheduledPayment?.claimType == CLAIM_TYPE.IP &&
        <GelBoxLayout alignmentIndividual={['center', null]} space={[0.1, 7]}
            style={{
                backgroundColor: themeColorBackgroundLight,
                paddingTop: sizeBaseX3,
                paddingBottom: sizeBaseX3,
                border: `0px solid ${themeColorGrayT10}`,
                borderWidth: `0px 0px 1px`
            }}>
            <GelIcon
                name="Cost"
                width={sizeBaseUnit * 5}
                color={themeColorBackgroundDark} style={{ marginLeft: sizeBaseX2 }} />
            <GelLink onClick={navigateToPayments}>{FormatHelper.stringFormat(message, nextScheduledPayment?.amount, formatDate(nextScheduledPayment?.paymentDate))}</GelLink>
        </GelBoxLayout>


    return (
        <GelContainerLite gutter="medium" style={{
            paddingTop: 0,
            paddingBottom: sizeBaseX2 * 1,
            paddingLeft: sizeBaseX2 * 1,
            paddingRight: sizeBaseX2 * 1,
        }}>
            {requirements}
        </GelContainerLite>
    );
};

export default NextPayment;